module.exports = __webpack_public_path__ + "static/boris-palmer-img-0484e1eee51fc4635209bb572c264c68.png";